import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, take, throwError } from 'rxjs';

import { AuthService } from '../services/auth/auth.service';
import { URLs } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // El endpoint de refresh usa el refreshToken como Bearer, no el accessToken
  if (req.url === URLs.refreshToken) {
    const refreshToken = authService.getRefreshToken();
    return next(
      refreshToken
        ? req.clone({ setHeaders: { Authorization: `Bearer ${refreshToken}` } })
        : req
    );
  }

  // Adjuntar accessToken a la request
  const token = authService.getToken();
  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  // Si hay un refresh en curso, esperar el nuevo token y reintentar
  if (authService.refreshInProgress) {
    return authService.refreshDone$.pipe(
      take(1),
      switchMap(newToken =>
        next(req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } }))
      )
    );
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return authService.refreshAccessToken().pipe(
          switchMap(newToken =>
            next(req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } }))
          ),
          catchError(err => {
            authService.logout();
            return throwError(() => err);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
